(function () {
  var root = document.querySelector('[data-palette-tool]');
  if (!root) return;

  var PALETTES = {
    modern: { label: 'Modern', collection: 'style-modern',
      description: 'Clean lines, neutral tones, and function-first design with minimal ornamentation.',
      examples: 'Sleek sofas, matte black hardware, glass and metal accents, uncluttered surfaces.',
      colors: [
      { hex: '#1C1C1E', name: 'Charcoal' }, { hex: '#F5F3EF', name: 'Warm White' },
      { hex: '#8C8C88', name: 'Stone Grey' }, { hex: '#C9A35F', name: 'Brass Gold' }, { hex: '#3A3A3C', name: 'Slate' }
    ]},
    japandi: { label: 'Japandi', collection: 'style-japandi',
      description: 'A blend of Japanese minimalism and Scandinavian warmth, built around natural materials and quiet, functional forms.',
      examples: 'Low-profile furniture, light wood tones, linen textiles, handcrafted ceramics.',
      colors: [
      { hex: '#EDE6DA', name: 'Rice Paper' }, { hex: '#A9906F', name: 'Oak' },
      { hex: '#5C6B57', name: 'Moss' }, { hex: '#2B2620', name: 'Ink' }, { hex: '#D8CDBC', name: 'Linen' }
    ]},
    'organic-modern': { label: 'Organic Modern', collection: 'style-organic-modern',
      description: 'Modern simplicity softened with natural materials and curved, imperfect silhouettes.',
      examples: 'Rattan and wood furniture, stone and clay accents, organic-shaped mirrors or vases.',
      colors: [
      { hex: '#E8E2D4', name: 'Sand' }, { hex: '#7C8B6F', name: 'Sage' },
      { hex: '#B08D6A', name: 'Terracotta Clay' }, { hex: '#FFFFFF', name: 'Chalk' }, { hex: '#4A4438', name: 'Bark' }
    ]},
    scandinavian: { label: 'Scandinavian', collection: 'style-scandinavian',
      description: 'Light, airy, and cozy, built around function, simplicity, and natural light.',
      examples: 'Light oak furniture, wool throws, simple pendant lighting, pale muted color schemes.',
      colors: [
      { hex: '#FAF9F6', name: 'Snow' }, { hex: '#D9C8A9', name: 'Light Oak' },
      { hex: '#A9B4A6', name: 'Sage Grey' }, { hex: '#2E2C29', name: 'Charcoal Wood' }, { hex: '#E3DCCF', name: 'Birch' }
    ]},
    industrial: { label: 'Industrial', collection: 'style-industrial',
      description: 'Raw, utilitarian materials inspired by warehouses and converted lofts.',
      examples: 'Exposed metal frames, reclaimed wood, black iron fixtures, factory-style lighting.',
      colors: [
      { hex: '#2B2B2B', name: 'Blackened Steel' }, { hex: '#6E6259', name: 'Raw Concrete' },
      { hex: '#8A3324', name: 'Rust' }, { hex: '#D9D2C7', name: 'Bone' }, { hex: '#403C36', name: 'Iron' }
    ]},
    'mid-century': { label: 'Mid-Century', collection: 'style-mid-century',
      description: 'Retro-inspired design from the 1950s–60s, known for tapered legs and bold warm colors.',
      examples: 'Walnut wood furniture, sunburst mirrors, teal or mustard upholstery, geometric patterns.',
      colors: [
      { hex: '#D97B45', name: 'Burnt Orange' }, { hex: '#3E5C50', name: 'Deep Teal' },
      { hex: '#E8C468', name: 'Mustard' }, { hex: '#F2EBDD', name: 'Cream' }, { hex: '#5C4033', name: 'Walnut' }
    ]},
    minimalist: { label: 'Minimalist', collection: 'style-minimalist',
      description: 'Pared-back design where every piece earns its place, with nothing extra.',
      examples: 'Monochrome palettes, hidden storage, unadorned furniture, open uncluttered floor space.',
      colors: [
      { hex: '#FFFFFF', name: 'Pure White' }, { hex: '#E8E8E6', name: 'Fog' },
      { hex: '#B5B5B0', name: 'Pebble' }, { hex: '#1A1A1A', name: 'Black' }, { hex: '#D6D6D0', name: 'Mist' }
    ]},
    coastal: { label: 'Coastal', collection: 'style-coastal',
      description: 'Breezy and relaxed, inspired by beach and seaside living.',
      examples: 'Whitewashed wood, woven jute rugs, linen slipcovers, blue or seafoam accents.',
      colors: [
      { hex: '#F4F1EA', name: 'Sandy White' }, { hex: '#A9C4D1', name: 'Sea Glass' },
      { hex: '#3F5F6E', name: 'Deep Ocean' }, { hex: '#D9C8A0', name: 'Driftwood' }, { hex: '#7C9A92', name: 'Seafoam' }
    ]},
    farmhouse: { label: 'Farmhouse', collection: 'style-farmhouse',
      description: 'Rustic charm meets everyday comfort, blending vintage and practical pieces.',
      examples: 'Shiplap walls, distressed wood tables, wrought iron hardware, cozy gingham or plaid textiles.',
      colors: [
      { hex: '#F7F3EA', name: 'Cream White' }, { hex: '#6B7561', name: 'Sage Green' },
      { hex: '#8B5E3C', name: 'Saddle Brown' }, { hex: '#2E2A24', name: 'Charcoal' }, { hex: '#D8CBB5', name: 'Wheat' }
    ]},
    traditional: { label: 'Traditional', collection: 'style-traditional',
      description: 'Classic and richly detailed, drawing from 18th- and 19th-century European design.',
      examples: 'Dark wood furniture, tufted upholstery, ornate mirrors, rich jewel-toned fabrics.',
      colors: [
      { hex: '#5A2E2C', name: 'Mahogany' }, { hex: '#C9A66B', name: 'Antique Gold' },
      { hex: '#2D3B45', name: 'Navy' }, { hex: '#EDE3D3', name: 'Ivory' }, { hex: '#7A2E2E', name: 'Wine' }
    ]},
    luxury: { label: 'Luxury', collection: 'style-luxury',
      description: 'Opulent materials and refined finishes, designed to make a statement.',
      examples: 'Velvet upholstery, marble surfaces, brass or gold hardware, statement chandeliers.',
      colors: [
      { hex: '#0F0F0F', name: 'Onyx' }, { hex: '#C9A227', name: 'Champagne Gold' },
      { hex: '#F5F0E8', name: 'Pearl' }, { hex: '#3B2F2F', name: 'Espresso' }, { hex: '#8A7B6C', name: 'Bronze' }
    ]},
    bohemian: { label: 'Bohemian', collection: 'style-bohemian',
      description: 'Eclectic and layered, mixing global influences, pattern, and texture freely.',
      examples: 'Macrame wall hangings, patterned rugs, rattan furniture, an abundance of plants.',
      colors: [
      { hex: '#A63A3A', name: 'Terracotta Red' }, { hex: '#D9A441', name: 'Turmeric' },
      { hex: '#4E6E58', name: 'Jungle Green' }, { hex: '#5C3A54', name: 'Plum' }, { hex: '#E8D9BE', name: 'Sand' }
    ]}
  };

  var styleGrid = root.querySelector('[data-palette-style-grid]');
  var selectStep = root.querySelector('[data-palette-step="select"]');
  var resultStep = root.querySelector('[data-palette-step="result"]');
  var styleNameEl = root.querySelector('[data-palette-style-name]');
  var styleDescEl = root.querySelector('[data-palette-style-description]');
  var swatchesEl = root.querySelector('[data-palette-swatches]');
  var shopLinkEl = root.querySelector('[data-palette-shop-link]');
  var moodBoardLinkEl = root.querySelector('[data-palette-mood-board-link]');
  var backBtn = root.querySelector('[data-palette-back]');

  function renderStyleGrid() {
    styleGrid.innerHTML = Object.keys(PALETTES).map(function (key) {
      var p = PALETTES[key];
      var chips = p.colors.slice(0, 5).map(function (c) {
        return '<span class="palette-tile__chip" style="background:' + c.hex + '"></span>';
      }).join('');
      return '<button type="button" class="palette-tile" data-style="' + key + '">' +
        '<span class="palette-tile__chips">' + chips + '</span>' +
        '<span class="palette-tile__label">' + p.label + '</span>' +
        '<span class="palette-tile__hint">' + p.description + '</span>' +
        '</button>';
    }).join('');

    Array.prototype.forEach.call(styleGrid.querySelectorAll('.palette-tile'), function (btn) {
      btn.addEventListener('click', function () {
        showResult(btn.getAttribute('data-style'));
      });
    });
  }

  function showResult(key) {
    var p = PALETTES[key];
    if (!p) return;
    styleNameEl.textContent = p.label;
    styleDescEl.innerHTML = '<p>' + p.description + '</p><p class="palette-examples"><strong>Look for:</strong> ' + p.examples + '</p>';
    swatchesEl.innerHTML = p.colors.map(function (c) {
      return '<div class="palette-swatch">' +
        '<div class="palette-swatch__color" style="background:' + c.hex + '" data-copy="' + c.hex + '"></div>' +
        '<div class="palette-swatch__name">' + c.name + '</div>' +
        '<div class="palette-swatch__hex">' + c.hex.toUpperCase() + '</div>' +
        '</div>';
    }).join('');
    shopLinkEl.href = '/collections/' + p.collection;
    // Color Palette's keys already match Mood Board's STYLES object keys
    // exactly (e.g. "organic-modern", "mid-century"), so the canonical key
    // itself is passed through with no translation. Style only -- no
    // palette/hex values are passed in this first handoff.
    if (moodBoardLinkEl) {
      moodBoardLinkEl.href = '/pages/mood-board?style=' + encodeURIComponent(key);
    }

    Array.prototype.forEach.call(swatchesEl.querySelectorAll('.palette-swatch__color'), function (el) {
      el.addEventListener('click', function () {
        var hex = el.getAttribute('data-copy');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(hex).then(function () {
            var nameEl = el.parentElement.querySelector('.palette-swatch__hex');
            var original = nameEl.textContent;
            nameEl.textContent = 'Copied!';
            setTimeout(function () { nameEl.textContent = original; }, 1200);
          });
        }
      });
    });

    selectStep.hidden = true;
    resultStep.hidden = false;
  }

  backBtn.addEventListener('click', function () {
    resultStep.hidden = true;
    selectStep.hidden = false;
  });

  renderStyleGrid();
})();
